import React from 'react';

export function IllustrationManOnLadder(props) {
  return (
    <svg {...props} viewBox="0 0 556 531" xmlns="http://www.w3.org/2000/svg">
      <g fill="none">
        <path
          d="M112.37 397.2c63.59-1 127.58-38.28 174.51-76.64 61.75-50.47 108.85-125.67 101.53-208C381.55 35.4 306.12-4.12 234.87.34 199.08 2.58 162.72 15.21 136.21 40 104 70.12 97.52 115.05 84.34 155c-15.54 47.13-51 74.8-74.34 117-29.77 53.75 11.35 109.31 66.12 121.62a153.67 153.67 0 0 0 36.25 3.58z"
          fill="#9973FF"
          opacity=".1"
        />
        <path
          d="M224.48 373.83c-8.47 4.72-11.45 25.71 2.32 23.7 3.17-.46 1.82-5.28-1.33-4.82-4.24.62-3.41-5.91-2.77-8.22.72-2.62 1.86-5 4.3-6.34 2.82-1.57.3-5.89-2.52-4.32zm91.19 20.6c-.9 4.57-1.55 9.84 2 13.53 3.55 3.69 9.41 3 13.7 1.36 3-1.13 1.68-6-1.33-4.82-2.48.94-6.78 2.18-8.86-.13-2.08-2.31-1.2-5.95-.68-8.61.62-3.15-4.2-4.49-4.82-1.33h-.01z"
          fill="#491E4F"
        />
        <path
          d="M432.08 28.89s6.29 2.4 7.94 1.43c1.65-.97 7.47-5 7.47-5l1.38-1.17s-.4-2.25-4.28.48c-3.88 2.73-2.7.35-2.7.35l2.58-3.82 2.81-4.94a2.6 2.6 0 0 0-.45-3.6l-.78-.63a2.61 2.61 0 0 0-2.89-.26C441 13 437 15.55 435.17 19l-4.61 8.66 1.52 1.23z"
          fill="#00E7E3"
        />
        <g style={{ mixBlendMode: 'multiply' }} fill="#6C12D6">
          <path d="M550.14 521.27h5.23l-121.38-453h-5.23zm-71.4 0h5.23l-121.39-453h-5.21z" />
          <path d="M438.89 96.35l-1.39-5.22h-73.15l1.4 5.22zm10.68 39.84l-1.4-5.22h-73.15l1.41 5.22zm10.67 39.84l-1.4-5.23H385.7l1.4 5.23zm10.67 39.83l-1.39-5.22h-73.15l1.41 5.22zm10.68 39.84l-1.4-5.23h-73.14l1.4 5.23zm10.68 39.84l-1.4-5.23h-73.15l1.4 5.23zm10.67 39.83l-1.4-5.22h-73.15l1.41 5.22zm10.68 39.84l-1.4-5.22h-73.15l1.4 5.22zm10.67 39.83l-1.4-5.22h-73.14l1.39 5.22zm10.67 39.84l-1.4-5.22h-73.14l1.4 5.22zm10.68 39.84l-1.4-5.22h-73.15l1.4 5.22z" />
        </g>
        <path
          d="M240.69 521.27h-5.22l121.39-453h5.22zm71.41 0h-5.22l121.38-453h5.22z"
          fill="#491E4F"
        />
        <path
          d="M351.94 96.35l1.4-5.22h73.15l-1.4 5.22zm-10.67 39.84l1.39-5.22h73.15l-1.4 5.22zm-10.68 39.84l1.4-5.23h73.14l-1.39 5.23zm-10.67 39.83l1.4-5.22h73.15l-1.4 5.22zm-10.67 39.84l1.39-5.23h73.16l-1.41 5.23zm-10.68 39.84l1.4-5.23h73.14l-1.39 5.23zm-10.67 39.83l1.4-5.22h73.14l-1.4 5.22zm-10.67 39.84l1.39-5.22h73.15l-1.4 5.22zm-10.69 39.83l1.41-5.22h73.14l-1.39 5.22zm-10.67 39.84l1.4-5.22h73.15l-1.4 5.22zm-10.66 39.84l1.39-5.22h73.15l-1.41 5.22z"
          fill="#491E4F"
        />
        <path
          d="M431.83 23.91s-35.9 39.11-42.65 47c0 0-2.17 1.82-4.89 4.51-11.91 8-35.42 27.07-39 30-4.88 4 3.06 20.48 8.73 31.25 0 0 30.19-29.6 46.28-50.84 8.2-8 16.22-17 20.35-22.84A303.18 303.18 0 0 0 440 31.33l-8.17-7.42zM289.41 185.37L317 304.74s19.13 14.39 20-14.24c.87-28.63 12.71-92.64 12.71-92.64l-60.3-12.49z"
          fill="#6C12D6"
        />
        <path
          d="M313.64 291.1l.6 104.26 7.73-.23s20.29-105.79 13.57-110c-6.72-4.21-21.7 1.05-21.9 5.97z"
          fill="#6C12D6"
        />
        <path
          d="M288.1 193.84l-11.49 93.82-56.56 89.16 8.58 1.95c9.4-8 18.59-16.35 27.61-24.82a472.23 472.23 0 0 0 21.35-21.11c27-28.75 32.09-68 45.73-104 2.69-7.1 7.42-26.77 8-34.47.36-3.93-43.22-.53-43.22-.53z"
          fill="#9973FF"
        />
        <path d="M344.77 202.23l.52-7.9 2.46.17-.53 7.9z" fill="#1F4058" />
        <path
          d="M287.06 211.8c21 .13 41.8.69 62.57 2.66.68-3.82 8.73-35.52 13.7-49.44 9.45-26.56 1.37-60.15-4.39-64.05-2.79-1.89-4.15-3.44-21.67-3.74-9.08-.16-24.3.44-36 5.92-6.76 3.17-11.68 8-12.1 15.22-1.38 23.71 0 46.44-5 70.16-.11.53-2.2 7.82-4 14.12a7.19 7.19 0 0 0 6.89 9.15z"
          fill="#6C12D6"
        />
        <path
          d="M386.26 205.93c1.46.53 3.07.53 4.53 0a3 3 0 0 1 1.61-.17c-.41 1.22.49 2 1.16 3.18 1.42-1.4 3-3.83 6.32-7.14.59-4.19-8.7-8.16-10.95-2.57l-2.67 6.7z"
          fill="#00E7E3"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M349.73 174.46c-3.21-1.55-7.59-4.71-12.31-6.37-1.95-4.37-6.95-13.06-10.53-22-7.84-19.58-11.75-27-16.68-35.7-5.61-9.9-14.09-6.68-18.74 2.19-3.72 7.1-1.82 12.84 1.52 19.37 4.25 8.34 7.21 16.36 12.27 24.22 4.78 7.41 11.51 14.29 15.78 21.87 1.64 2.9 5.11 6.37 12.32 9.46 16.22 7 52.9 18.41 52.9 18.41l3.85-8.36s-33.2-19.62-40.38-23.09z"
          fill="#6C12D6"
        />
        <path
          d="M346 73.94c2-5.67.27-15.32-1.62-21-1.31-3.89-3.8-8.93-7.75-10.91-6.21-3.11-14.47-.85-18.18 4.17-4.15 5.61-3.38 14.68-2.82 21.48.66 8.08 3.71 31.49 3.71 31.49 11.7 12.92 32.12 5.22 21.91-1.7-2.6-1.76.19-17 2.25-19.32a12.5 12.5 0 0 0 2.5-4.21z"
          fill="#00E7E3"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M315.77 78.33l-3.59-11.21c-1.81-5.7-6.23-12.34-4.23-18.65 2.42-7.66 9.47-13.18 16.37-16.68 4.41-2.24 25.67-11.61 22.64.5-1.18 4.73-20.11 19.28-25 14 3.5 1.5 6.2 4.44 7.38 8.06l2.37 12-3.29 2.06v.33s-2.17-6.44-6.81-7.39c-4.64-.95-5.79 4.18-2.51 7.26 3.28 3.08 3.47 4.55 3.47 4.55l-2.74 6.45-4.06-1.28z"
          fill="#6C12D6"
        />
        <path
          d="M334.66 58.34a1.77 1.77 0 0 1 3.13-.85c.89.94 2.3-.48 1.42-1.41a3.78 3.78 0 0 0-6.48 1.72c-.29 1.26 1.64 1.79 1.93.54zm11.76-4.46a2 2 0 0 1 3.08-.45c.9.93 2.32-.49 1.42-1.41a4 4 0 0 0-6.23.85c-.61 1.14 1.11 2.15 1.73 1v.01zm-2.99 10.66c1.59-.45 4.84-.69 4.07-3.08-.52-1.62-1.85-3.28-2.69-4.75l-3-5.18a1 1 0 0 0-1.73 1l3.82 6.67c.25.44 1.83 2.54 1.69 3 .17-.54-2.26.31-2.74.44a1 1 0 1 0 .54 1.93l.04-.03zm-4.93 4.64a5.56 5.56 0 0 0 7 1.23 1 1 0 0 0-1-1.73 3.58 3.58 0 0 1-4.57-.91c-.81-1-2.22.42-1.41 1.41h-.02z"
          fill="#6C12D6"
        />
        <path
          d="M366.17 523.54c.66 7.84-82.73 5.52-91.94 5.58-18.18.1-37.85.46-56.6.1-11.79-.23-45.68 5.68-53.9-5.63a2.5 2.5 0 0 1 2.11-1.7c3.79-1.87 10.92-1.82 15.26-2.17a489 489 0 0 1 23.3-1.16c49-1.51 98.3-1.46 147.29 2 3.23.16 6.45.53 9.64 1.11 1.19.33 4.73.66 4.84 1.87z"
          fill="#9973FF"
          opacity=".2"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components-legacy/SVG/IllustrationManOnLadder.js